import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "../../../../../components/UniversalModalOverride";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
	{
		name: 'UPC Center',
		url: '/products/upc_center',
		icon: 'barcode',
	},
];

export default class UPCS extends Framework.Components.View {
	constructor(props) {
		super(props,' ');
	}
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
				<Button data-id={"add-upc"} onClick={this.toggle('modalUPCAdd')} size={"sm"} color="primary">
					<i className="fa fa-barcode"/>&nbsp;&nbsp;Add UPC
				</Button>
			</Framework.Components.PageBar>

				<div>
					<Collections.UPCS
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
					/>
				</div>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"UPC"}
					object={Objects.UPCAdd}
					history={this.props.history}
					toggle={this.state['modalUPCAdd']}
					reportClose={this.reportClose('modalUPCAdd')}
					afterSave={this.handleAfterSave}
					size={"xl"}
					objectProps={{scannedCode: this.state['modalUPCAdd'] ? this.props.scannedCode : null}}
				/>

			</div>
		);
	}
}

